import {ApiPathsService} from "../../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {DynamicEditComponent} from "../../../../app/shared/dynamic-edit/dynamic-edit.component";
import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../../app/shared/models/campo-aggiuntivo";
import {GetCarrelloVoci, getSpedizione, ImageUrl, PrezzoIvato} from "../ProductUtility";
import {dateTimeStringToFormattedDate} from "../../../Utility/DateUtility";
import {getOrderStatus} from "../I miei Ordini";
import {environment} from "../../../BaseEnvironments/EmmeEvolution_Marketplace";

const oreScadenzaOrdine = environment?.oreScadenzaOrdine ?? 48;

function diffOre(dataInizio, dataFine) {
  if (!dataInizio || !dataFine) return null;

  const inizio = new Date(dataInizio).getTime();
  const fine = new Date(dataFine).getTime();

  if (isNaN(inizio) || isNaN(fine)) return null;

  return (fine - inizio) / (1000 * 60 * 60);
}

function getTipoAnnullamentoOrdine(ordine) {
  if (!ordine.annullato) return null;
  const dataAnnullato = ordine.dataAnnullato;

  if (!ordine.dataDisponibilita) {
    const ore = diffOre(ordine.dataInserimento, dataAnnullato);
    if (ore !== null && ore > oreScadenzaOrdine ) {
      return 'scaduto_venditore';
    }
    return 'annullato';
  }

  const ore = diffOre(ordine.dataDisponibilita, dataAnnullato);

  if (ore !== null && ore > oreScadenzaOrdine ) {
    return 'scaduto_acquirente';
  }

  return 'annullato';
}

function getTipoBadge(ordine){
  return ordine.clienteObject?.tipiObject?.some(tipo => tipo?.label?.toLowerCase().includes('b2b')) ? `<span class="ord-badge tipo-ret">Retailer</span>`:`<span class="ord-badge tipo-cons">Consumatore</span>`
}

function getOrderStatusGlobali(ordine) {
  if (ordine.annullato) return 'annullato';
  if (ordine.data_conferma) return 'evaso';
  if (ordine.data_creazione && ordine.dataDisponibilita) return 'confermato';
  if (ordine.data_creazione) return 'da_confermare';
  return '';
}
function getStatusBadge(ordine){
  const tipoAnnullamento = getTipoAnnullamentoOrdine(ordine);

  if (tipoAnnullamento === 'scaduto_venditore') {
    return `<span class="ord-badge annullato">⏱ Scaduto dal venditore</span>`;
  }

  if (tipoAnnullamento === 'scaduto_acquirente') {
    return `<span class="ord-badge annullato">⏱ Scaduto dall'acquirente</span>`;
  }
  switch(getOrderStatusGlobali(ordine)){
    // 'da_confermare' | 'confermato' | 'preparazione' | 'spedito' | 'consegnato'
    case 'da_confermare':
      return `<span class="ord-badge attesa" style="">⏳ In attesa</span>`
    case 'confermato':
      return `<span class="ord-badge confermato" style="">✔ Confermato</span>`
    case 'annullato':
      if (ordine?.dataAnnullatoCliente) {
        return `<span class="ord-badge annullato" style="">✕ Annullato acquirente</span>`;
      }
      return `<span class="ord-badge annullato" style="">✕ Annullato venditore</span>`;
    case 'evaso':
      return `<span class="ord-badge evaso" style="">✓ Evaso</span>`
  }
  return `STATO`;
}

function Ordini() {
  var OBJ: OggettoConfig = {
    Id: "ordini",
    RestRoute: '/progetti/progetti',
    ListResponseHasData:true,
    listTitle: 'Ordini globali',
    noActionLabel:true,
    ListDefaultFilter:{
      stato_prog: 'T',
      stato_progObject: { id: 'T', label: 'Tutti gli stati' },
      periodo:false,
      orderByData: 'desc',
      stato_ord: 'G'
    },
    PrintHeaders:[],
    asyncFullResponseMap: async (response, component, callback) => {
      const filtro = component.filtro;

      console.log("Filtro attivo:", filtro);

      let data = response.data;

      if (filtro.tipo === 30) {
        data = data.filter(x =>
          x.clienteObject?.tipiObject?.some(t => t.id === 30)
        );
      }

      if (filtro.tipo === 31) {
        data = data.filter(x =>
          !x.clienteObject?.tipiObject?.some(t => t.id === 30)
        );
      }
      /*if (filtro.statoFiltro) {
        data = data.filter(x => {

          if (filtro.statoFiltro === 'G') {
            return x.annullato === true && x.stato_prog === 'G';
          }

          return x.annullato === false && x.stato_prog === filtro.statoFiltro;
        });
      }*/


      const stats = {
        totale: response.total,
        annullati: response.annullate,
        attesa: response.nonConfermati,
        confermati: response.confermatiDisp,
        evasi: response.evasi
      };

      (window as any).ordiniStats = stats;
      callback({
        ...response,
        data: data
      });    },
    Filters:[
      CampoAggiuntivo.Html("", (x, parent) => {
        const stats = (window as any).ordiniStats || {};
        return `
    <div class="ord-stats">

      <div class="stat-box attesa">
        <div class="num">${stats.attesa ?? 0}</div>
        <div class="label">⏳ In attesa</div>
      </div>

      <div class="stat-box confermati">
        <div class="num">${stats.confermati ?? 0}</div>
        <div class="label">✔ Confermati</div>
      </div>

      <div class="stat-box evasi">
        <div class="num">${stats.evasi ?? 0}</div>
        <div class="label">✔ Evasi</div>
      </div>

      <div class="stat-box annullati">
        <div class="num">${stats.annullati ?? 0}</div>
        <div class="label">✕ Annullati</div>
      </div>

      <div class="stat-box totale">
        <div class="num">${stats.totale ?? 0}</div>
        <div class="label">Totale</div>
      </div>

    </div>
  `;

      }, () => true, { class: 'col-12 mb-2' }),
      CampoAggiuntivo.SingleDropdown(
        "",
        "stato_prog",
        [
          { id: "T", label: "Tutti gli stati" },
          { id: "DC", label: "⏳ In attesa" },
          { id: "DI", label: "✔ Confermati" },
          { id: "CO", label: "✔ Evasi" },
          { id: "G", label: "✕ Annullati" }
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "Tutti gli stati",
          OnChangeFunc: (x) => {
            if (!x.stato_prog || x.stato_prog === "T") {
              x.stato_prog = "T";

              return;
            }

            if (x.stato_prog === "G") {
              x.annullati = true;
              return;
            }

            x.annullati = false;
          }
        },
        "col-lg-2 mt-3",
        () => true,
        {
          singleSelection: true,
          singleOutput: true
        }
      ),
      CampoAggiuntivo.SingleDropdown(
        "",
        "tipo",
        [
          { id: null, label: "Tutti i tipi" },
          { id: 30, label: "Retailer" },     // B2B
          { id: 31, label: "Consumatore" }   // B2C
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "Tutti i tipi"
        },
        "col-lg-2 mt-3",
        () => true,
        {
          singleSelection: true,
          singleOutput: true
        }
      ),
      CampoAggiuntivo.SingleDropdown("", "negozio", '/anagrafica/clienti/list', "nominativo", {
        parameter: [
          { nome: 'stati', value: [91] },
          { nome: 'page', value: 0 },
          { nome: 'size', value: 50 }
        ],
        responseHasData: true,
        hideLabel: true,
        placeholder: 'Tutti i Venditori'
      }, 'col-lg-3 mt-3', () => true, {
        dataLabel: "Venditore",
        singleSelection: true,
        singleOutput: true,
        enableCheckAll: false
      }),

    ],
    Headers:[
      CampoAggiuntivo.TextField("N° ORDINE", 'progressivo', 'col-12', {modificabile:false}),
      CampoAggiuntivo.InputField("data", 'data_creazione', 'date', 'col-12', {modificabile:false}),
      CampoAggiuntivo.Html("Venditore", (x)=> `${x.oggetto || '-'}`),
      CampoAggiuntivo.Html("Acquirente", (x)=> `${x.clienteObject?.soprannome || '-'}`),
      //CampoAggiuntivo.Html("Articolo", (x)=> ``),
      CampoAggiuntivo.Html("Tipo", (x)=>getTipoBadge(x)),
      CampoAggiuntivo.Html("Importo", (x)=> `${x.totaleOrdine.toDecimals(2)}`),
      CampoAggiuntivo.Html("Stato", (x)=> getStatusBadge(x)),
      CampoAggiuntivo.Html("Scadenza", (x)=> `${x.scadenza || '-'}`),
    ],
    AzioniLista: [
      {
        nome: 'Visualizza Dettaglio',
        close: false,
        icon: '',
        iconLabel: 'Visualizza dettaglio',
        class: ' btn btn-o',
        style: {
          'padding': '5px 12px',
          'font-size': '12px',
          'white-space': 'nowrap',
        },
        single: true,
        labelClass: 'text-success ',
        type: 'func',
        tooltip: "",
        func: (
          Item: any,
          api: ApiPathsService,
          onEnd: () => void,
          Toastr: ToastrService,
          component: DynamicCrudService
        ) => {
          const EditModal = component.modalService.open(DynamicEditComponent, {
            centered: true,
            backdrop: 'static',
            container: '#main-wrapper',
            size: 'xl'
          });

          const obj = Item ? Object.assign({}, Item ?? {}) : {};

          (<DynamicEditComponent>EditModal.componentInstance).CrudSettings =
            OrdineGlobaleDettaglio();

          (<DynamicEditComponent>EditModal.componentInstance).Item = obj;
        },
      }
    ],

    MenuItems:[
      {
        path: 'shared/dynamiclist/ordini',
        title: "Ordini globali",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
        notruoliOperativi: ['C']

      }
    ]
  }
  return OBJ;
}
function OrdineGlobaleDettaglio(): OggettoConfig {
  return {
    Id: 'ordine_globale_dettaglio',
    NoSave: true,
    RestRoute: '/progetti/progetti',
    Label: 'Dettagli dell\'ordine',
    GetResponseHasData: true,

    asyncMap: (ordine, component, callback) => {
      const vociTable = [];

      ordine.progetti?.forEach(progetto => {
        progetto.voci?.forEach(voce => {
          vociTable.push({
            ...voce,
            tagliaLabel: voce.tagliaObject?.taglia ?? '',
            coloreLabel: voce.coloreObject?.[0]?.check ?? ''
          });
        });
      });
      component.api.ClassicGet("/progetti/costi/spedizione").subscribe((res:{id:number, check:string, codice:string}[]) => {
        console.log("spedizione get", res);
        var costoFisso = res.filter(x=>x.id==5).reduce((a, b) => a + parseFloat(b.codice), 0);
        console.log("costo Fisso Spedizione: ", costoFisso);
        var perc = res.filter(x=>x.id==6).reduce((a, b) => a + parseFloat(b.codice), 0);
        console.log("% Maggiorazione Spedizione", perc);
        ordine.costoSpedizione = costoFisso;
        ordine.percSpedizione = perc;
        function GetSpedizione(ordine) {
          var prod = GetCarrelloVoci([ordine])?.map(x => ({prodotto_cart: x, prodotto: x.prodottoObject}))
          console.log(prod);
          var sped = getSpedizione({esclusiva: ordine.esclusivaObject, items: prod}, ordine.percSpedizione, ordine.costoSpedizione)
          console.log(sped);

          return sped ?? 0;
        }
        ordine.sped = GetSpedizione(ordine);
      })

      ordine.vociTable = vociTable;
      callback(ordine);
    },

    campi: [
      CampoAggiuntivo.Html("", (ordine, parent) => `
        <div id="ordDetBody">
          <div class="ord-det-grid">
            <div class="ord-det-left">
              <div class="ord-det-lbl">Venditore</div>
              <p class="nome-negozio">${ordine?.oggetto ?? '-'}</p>
              <p class="dettaglio-negozio">
                Acquirente: ${ordine?.clienteObject?.soprannome ?? '-'}<br>
                Email: ${ordine?.clienteObject?.email ?? '-'}<br>
                Telefono: ${ordine?.clienteObject?.telefono ?? '-'}
              </p>
            </div>

            <div class="ord-det-right">
              <div class="ord-det-lbl">Riepilogo ordine</div>
              <div class="ord-det-info-row">
                <span>Ordine</span>
                <span class="font-monospace">${ordine.progressivo}</span>
              </div>
              <div class="ord-det-info-row">
                <span>Tipo</span>
                <span>${getTipoBadge(ordine)}</span>
              </div>
              <div class="ord-det-info-row">
                <span>Stato</span>
                <span>${getStatusBadge(ordine)}</span>
              </div>
              <div class="ord-det-info-row">
                <span>Data</span>
                <span>${dateTimeStringToFormattedDate(ordine.data_creazione)}</span>
              </div>
              <div class="ord-det-info-row">
                <span>Spedizione</span>
                <span>${ordine.sped.toFixed(2)} €</span>
              </div>
            </div>
          </div>
        </div>
      `, () => true, { class: 'col-12' }),

      CampoAggiuntivo.TableField(
        "Articoli",
        [
          CampoAggiuntivo.Html(
            "",
            (x, parent) => `
              <div class="ord-art-img">
                <img
                  src="${ImageUrl(x, { ...parent, api: parent.apiPaths })}"
                  alt="${x.voce}"
                  class="d-gal-img"
                >
              </div>
            `,
            () => true,
            {
              class: 'col-auto',
              modificabile: false
            }
          ),

          CampoAggiuntivo.TextField("Articolo", "voce", "col-12", {
            modificabile: false
          }),

          CampoAggiuntivo.TextField("Taglia", "tagliaLabel", "col-12", {
            modificabile: false
          }),

          CampoAggiuntivo.TextField("Colore", "coloreLabel", "col-12", {
            modificabile: false
          }),

          CampoAggiuntivo.TextField("Quantità", "quantita", "col-12", {
            modificabile: false
          }),

          CampoAggiuntivo.Html(
            "Prezzo (€)",
            (x) => {
              const p = getVocePrezzoValues(x);

              if (!p.sconto) {
                return `€${p.prezzoInteroIvato.toDecimals(2)}`;
              }

              return `
                <div class="ordine-price-box">
                  <span class="ordine-old-dettaglio">€${p.prezzoInteroIvato.toDecimals(2)}</span>
                  <span class="ordine-promo-badge-dettaglio">-${p.sconto}%</span>
                  <span class="ordine-price-dettaglio">€${p.prezzoScontatoIvato.toDecimals(2)}</span>
                </div>
              `;
            },
            () => true,
            { modificabile: false }
          ),

          CampoAggiuntivo.Html(
            "Totale (€)",
            (x) => {
              const p = getVocePrezzoValues(x);

              if (!p.sconto) {
                return `
                  <span class="font-weight-bold">
                    €${p.importoIntero.toDecimals(2)}
                  </span>
                `;
              }

              return `
                <div class="ordine-price-box">
                  <span class="font-weight-bold">
                    <span class="ordine-old-dettaglio">€${p.importoIntero.toDecimals(2)}</span>
                    <span class="ordine-promo-badge-dettaglio">-${p.sconto}%</span>
                    <span class="ordine-price-dettaglio">€${p.importoScontato.toDecimals(2)}</span>
                  </span>
                </div>
              `;
            },
            () => true,
            { modificabile: false }
          )
        ],
        "vociTable",
        true,
        "col-12"
      )
    ],

    Azioni: []
  };
}
function getVocePrezzoValues(voce: any) {
  const iva = Number(voce.iva ?? 22);
  const quantita = Number(voce.quantita ??voce.quantitaRic  ?? 1);

  const prezzoNetto = Number(voce.prezzo ?? 0);
  const sconto = Number(voce.sconto ?? 0);

  const prezzoInteroIvato = PrezzoIvato(prezzoNetto, iva) ?? 0;

  const prezzoScontatoIvato = sconto > 0
    ? prezzoInteroIvato - ((prezzoInteroIvato / 100) * sconto)
    : prezzoInteroIvato;

  return {
    quantita,
    sconto,
    prezzoInteroIvato,
    prezzoScontatoIvato,
    importoIntero: prezzoInteroIvato * quantita,
    importoScontato: prezzoScontatoIvato * quantita
  };
}

export var OrdiniEnv = () => {
  var env: any = {
    Modules: {
      "Ordini": true
    },
    Cruds: [
      Ordini(),
      OrdineGlobaleDettaglio()
    ],
    Menu: [...Ordini().MenuItems]
  };

  return env;
};
